import { orderStatusHeaderStyles as styles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusHeader";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.printButton = {
    variant: "secondary",
};

styles.shareEntityButtonStyles = {
    ...styles.shareEntityButtonStyles,
    button: {
        color: "",
        variant: "secondary",
    },
};

styles.container = {
    ...styles.container,
    offsetCss: css`
        ${mediaQueriesBP.minLG} {
            align-items: center;
        }
    `,
};

styles.buttonsGridItem = {
    ...styles.buttonsGridItem,
    css: css`
        ${mediaQueriesBP.minLG} {
            align-items: center;
            justify-content: flex-end;
        }
    `,
};

styles.buttonsHidden = {
    ...styles.buttonsHidden,
    css: css`
        ${mediaQueriesBP.minLG} {
            display: flex;
            gap: 10px;
        }
    `,
};
